import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Fragment, useMemo } from 'react';
import { pathgen } from 'object-path-generator';
import { Box, TableList, Typography } from 'seagull';
import { useLocaleKeys } from '~/i18n';
import { utils } from '~/utils';
import styles from './BulkInvoiceDetails.module.scss';
import { CustomerChargesTable } from './CustomerChargesTable/CustomerChargesTable';
export const BulkInvoiceDetailsTestIds = pathgen('BulkInvoiceDetailsTestIds');
const columnDefs = [
    {
        width: 300,
        hAlign: 'start'
    },
    {
        width: 120,
        hAlign: 'start'
    },
    {
        width: 120,
        hAlign: 'start'
    },
    {
        width: 120,
        hAlign: 'end'
    }
];
const headerItems = [
    {
        value: 'Client'
    },
    {
        value: 'Bill Type'
    },
    {
        value: 'Issue Date'
    },
    {
        value: 'Total'
    }
];
export const BulkInvoiceDetails = (param)=>{
    let { invoices } = param;
    const { t } = useLocaleKeys('common');
    if (!invoices || invoices.length === 0) {
        return null;
    }
    const tableItems = useMemo(()=>invoices.map((invoice, index)=>{
            const invoiceId = "invoice-".concat(index);
            const agreementName = invoice.agreementName || t.untitledAgreement();
            return {
                id: invoiceId,
                customerIndex: index,
                invoice,
                cells: [
                    {
                        content: /*#__PURE__*/ _jsxs(Box, {
                            children: [
                                /*#__PURE__*/ _jsx(Typography, {
                                    ellipsis: true,
                                    variant: "paragraph1",
                                    weight: "bold",
                                    testId: BulkInvoiceDetailsTestIds.CustomerRow.CustomerName(index),
                                    children: invoice.customerName
                                }),
                                /*#__PURE__*/ _jsx(Typography, {
                                    ellipsis: true,
                                    skin: "secondary",
                                    variant: "paragraph2",
                                    testId: BulkInvoiceDetailsTestIds.CustomerRow.Agreement(index),
                                    children: agreementName
                                })
                            ]
                        })
                    },
                    {
                        content: invoice.billType === 'BILL_NOW' ? 'Bill now' : 'Bill on date',
                        testId: BulkInvoiceDetailsTestIds.CustomerRow.BillType(index)
                    },
                    {
                        content: invoice.issueDate,
                        testId: BulkInvoiceDetailsTestIds.CustomerRow.IssueDate(index)
                    },
                    {
                        content: utils.formatDollarAmount(invoice.total),
                        testId: BulkInvoiceDetailsTestIds.CustomerRow.Total(index)
                    }
                ],
                testId: BulkInvoiceDetailsTestIds.CustomerRow.Root(index)
            };
        }), [
        invoices
    ]);
    return /*#__PURE__*/ _jsx(Box, {
        className: styles.container,
        testId: BulkInvoiceDetailsTestIds.Root(),
        children: /*#__PURE__*/ _jsx(TableList.Provider, {
            columnDefs: columnDefs,
            expandableRows: true,
            expandableRowsVariant: "clickableIconAndRow",
            children: /*#__PURE__*/ _jsx(TableList.Structure, {
                className: styles.visibleOverflow,
                header: /*#__PURE__*/ _jsx(TableList.Header, {
                    items: headerItems
                }),
                content: /*#__PURE__*/ _jsx(_Fragment, {
                    children: tableItems.map((item, customerIndex)=>/*#__PURE__*/ _jsx(Fragment, {
                            children: /*#__PURE__*/ _jsx(TableList.Row, {
                                testId: item.testId,
                                items: item.cells.map((cell)=>({
                                        value: cell.content,
                                        testId: cell.testId
                                    })),
                                expandedContent: ()=>/*#__PURE__*/ _jsx(CustomerChargesTable, {
                                        invoice: item.invoice,
                                        customerIndex: customerIndex
                                    }),
                                expandedContentClassName: styles.visibleOverflow
                            })
                        }, item.id))
                })
            })
        })
    });
};
